const fallbackLocale = 'en-US';
// gets locale from ESSP lang attribute within <html> tag
// eslint-disable-next-line import/prefer-default-export
export const getLocale = () => {
    const html = document.querySelector('html');
    return (html === null || html === void 0 ? void 0 : html.getAttribute('lang')) || fallbackLocale;
};
//# sourceMappingURL=LocaleParsing.js.map